import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';

interface NotesSectionProps {
  initialNotes?: string;
  notes: string;
  onChange: (notes: string) => void;
}

export function NotesSection({ initialNotes, notes, onChange }: NotesSectionProps) {
  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="border-b">
        <CardTitle>Visit Notes</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        {initialNotes && (
          <div className="mb-4">
            <Label className="text-gray-500">Initial Notes</Label>
            <p className="mt-1 p-3 rounded-md">{initialNotes}</p>
          </div>
        )}
        <Textarea
          value={notes}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter additional notes..."
          className="min-h-[200px]"
        />
      </CardContent>
    </Card>
  );
}
